import { render, staticRenderFns } from "./SignedFeedback.vue?vue&type=template&id=363751ce"
import script from "./SignedFeedback.vue?vue&type=script&lang=js"
export * from "./SignedFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports